import React from "react";
import { Box, Container, Stack } from "@mui/material";
import {
  DeleteOutlined,
  EditOutlined,
  InfoOutlined,
  OpenInNewOutlined,
  PhotoLibraryOutlined,
} from "@mui/icons-material";
import DataTable from "../tables/DataTable";
import ObjectCardGrid from "./ObjectCardGrid";
import ViewToggle, { useViewMode } from "./ViewToggle";
import { tokens } from "../theme/theme";

const RealEstateObjects = ({
  items,
  handleOpenInfo,
  handleOpenPhotos,
  handleEditItem,
  handleDeleteItem,
  onPageChanged,
  loadNextObjects,
  hasMore,
  admin,
  openViewPage,
  s3Client,
}) => {
  const [mode, setMode] = useViewMode("objects", "table");

  // Same actions the table row offers, in the same order, so switching views
  // does not mean relearning anything.
  const actions = [
    {
      key: "info",
      label: "Додаткова інформація",
      icon: <InfoOutlined sx={{ fontSize: 19 }} />,
      onClick: (item) => handleOpenInfo(item.id),
    },
    {
      key: "photos",
      label: "Фото",
      icon: <PhotoLibraryOutlined sx={{ fontSize: 19 }} />,
      onClick: (item) => handleOpenPhotos(item.id),
    },
    {
      key: "edit",
      label: "Редагувати",
      icon: <EditOutlined sx={{ fontSize: 19 }} />,
      onClick: (item) => handleEditItem(item.id),
    },
    {
      key: "open",
      label: "Відкрити на сайті",
      icon: <OpenInNewOutlined sx={{ fontSize: 19 }} />,
      onClick: (item) => openViewPage({ row: item }),
    },
  ];

  if (admin) {
    actions.push({
      key: "delete",
      label: "Видалити",
      icon: <DeleteOutlined sx={{ fontSize: 19 }} />,
      color: tokens.red600,
      onClick: (item) => handleDeleteItem(item.id),
    });
  }

  return (
    <Box>
      {/* px must equal the tables' `mx: { xs: 1, md: 2 }` (DataTable.js,
          ArchivesTable.js) — the toggle sits directly above whichever view is
          showing, so any other value makes its right edge miss the edge of the
          content below it in one of the two modes. */}
      <Container maxWidth={false} sx={{ px: { xs: 1, md: 2 } }}>
        {/* Both gaps belong to the toggle row, not to the view below it: the
            table brings no top margin of its own, so leaving the spacing to
            the content puts the toggle flush against the table's border in one
            mode and 16px clear of the cards in the other. 12px above comes from
            the filter bar's mb; 12px below is this pb. */}
        <Stack direction="row" justifyContent="flex-end" sx={{ pt: 0, pb: 1.5 }}>
          <ViewToggle mode={mode} onChange={setMode} />
        </Stack>
      </Container>

      {mode === "cards" ? (
        <ObjectCardGrid
          items={items}
          s3Client={s3Client}
          actions={actions}
          onOpen={(item) => openViewPage({ row: item })}
          loadNext={loadNextObjects}
          hasMore={hasMore}
        />
      ) : (
        <DataTable
          items={items}
          handleOpenInfo={handleOpenInfo}
          handleOpenPhotos={handleOpenPhotos}
          handleDeleteItem={handleDeleteItem}
          handleEditItem={handleEditItem}
          onPageChanged={onPageChanged}
          loadNextObjects={loadNextObjects}
          admin={admin}
          openViewPage={openViewPage}
        />
      )}
    </Box>
  );
};

export default RealEstateObjects;
